/** Badge tone used for customer-status chips across detail pages. */
export type CustomerStatusTone = 'success' | 'destructive' | 'secondary' | 'accent' | 'default';

/**
 * Human-readable label for a customer status. Handles the English/German mix
 * returned by the backend. null/undefined → em dash; unknown → the raw value.
 */
export function customerStatusLabel(status: string | null | undefined): string {
  if (!status) return '—';
  const labels: Record<string, string> = {
    active: 'Active', aktiv: 'Active',
    formerCustomer: 'Former',
    deactivated: 'Deactivated',
    futureCustomer: 'Future',
  };
  return labels[status] ?? status;
}

/** Badge tone for a customer status (see SPARTAN_STYLE_GUIDE §7.2 status → variant). */
export function customerStatusTone(status: string | null | undefined): CustomerStatusTone {
  switch (status) {
    case 'active': case 'aktiv': return 'success';
    case 'deactivated': return 'destructive';
    case 'formerCustomer': return 'secondary';
    case 'futureCustomer': return 'accent';
    default: return 'default';
  }
}
